import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionWatcherService {
  private http = inject(HttpClient);
  private initialVersion?: string;

  init(): void {
    // Fire and forget, no need to block bootstrap
    firstValueFrom(
      this.http.get<{ version: string }>('/assets/version.json', {
        params: { t: Date.now() },
      }),
    )
      .then(({ version }) => {
        this.initialVersion = version;
      })
      .catch((err) => {
        console.error('Version init failed', err);
      });
  }

  async checkAndReloadIfNeeded(): Promise<void> {
    const { version } = await firstValueFrom(
      this.http.get<{ version: string }>('/assets/version.json', {
        params: { t: Date.now() },
      }),
    );

    if (this.initialVersion && version !== this.initialVersion) {
      // Optional: clear local/session storage depending on how you use them
      // localStorage.clear();
      // sessionStorage.clear();
      location.reload();
    }
  }
}
